import React from 'react';
import OfficeIcon from '@mui/icons-material/BusinessRounded';
import {
  ChargeResponseProviderDTO,
} from 'dtos';
import Image, {
  ImageSize,
} from 'pages/Dashboard/components/Image';
import {
  getDisplayName,
} from 'pages/Dashboard/utils/helper';

type ProviderIconProps = ChargeResponseProviderDTO & {
  size?: ImageSize;
};

export default function ProviderIcon({
  size = 'sm',
  isOrganization,
  formattedNames,
}: ProviderIconProps) {
  return (
    <Image
      size={size}
      className="font-semibold"
      color={isOrganization ? '#9ca3af' : undefined}
      alt={getDisplayName(formattedNames)}
    >
      {isOrganization ? <OfficeIcon className="!w-4 !h-4 !text-white" /> : formattedNames?.initials}
    </Image>
  );
}
